import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";
import { ConfirmDialog } from "./components/AppointmentConfirmDialog";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

export function ConfirmAppointment() {
    const { idAppointment } = useParams();
    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(false);

    const notify = (message, type = "success") => {
        toast(message, {
            style: {
                background: type === "success" ? "#4caf50" : "#f44336",
                color: "#fff",
                padding: "16px",
                borderRadius: "8px",
            },
            duration: 4000,
        });
    };

    const fetchAppointments = async () => {
        try {
            setLoading(true);
            const data = await api.publicAppointments.getMulti(
                null,
                null,
                null,
                null,
                { token: idAppointment }
            );
            setAppointment(data);
        } catch (error) {
            console.error("Error al obtener el agendamiento:", error);
            notify(
                "No se encontró el turno o el enlace no es válido.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (data) => {
        try {
            setLoading(true);
            const response = await axios.patch(
                `${process.env.REACT_APP_API_BASE_URL}/appointments/public/`,
                data,
                { params: { token: idAppointment } }
            );
            fetchAppointments();
        } catch (error) {
            notify("Ocurrió un error. Inténtalo de nuevo.", "error");
            return api.publicAppointments._handleError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAppointments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idAppointment]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [y, m, d] = dateStr.split("-");
        return `${d}-${m}-${y}`;
    };
    const isPast = () => {
        if (!appointment?.date) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const appointmentDate = new Date(appointment.date);
        appointmentDate.setHours(0, 0, 0, 0);

        return appointmentDate < today;
    };
    return (
        <div className="h-[100dvh] w-[100dvw] flex justify-center items-center">
            {/* {appointment && !isPast() && (
                <ConfirmDialog
                    selectedAppointment={appointment}
                    formatDate={formatDate}
                    handleUpdate={handleUpdate}
                    notify={notify}
                    loading={loading}
                />
            )} */}
            <ConfirmDialog
                selectedAppointment={appointment}
                formatDate={formatDate}
                handleUpdate={handleUpdate}
                notify={notify}
                loading={loading}
            />
            {/* 
            {appointment && isPast() && (
                <div className="p-8 bg-yellow-100 text-yellow-800 rounded-lg text-center">
                    ⚠️ Este turno ya ha pasado y no se puede confirmar ni
                    cancelar.
                </div>
            )} */}

            <Toaster />
        </div>
    );
}
